// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_ConfigProvidersResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Invoice_ConfigProviderRow } from './Invoice_ConfigProviderRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Invoice_ConfigProvidersResponseDados {
providers: Invoice_ConfigProviderRow[]
}

export type Invoice_ConfigProvidersResponse = ApiResponse<Invoice_ConfigProvidersResponseDados>;

registerResponseContract('Invoice_ConfigProvidersResponse', {
  providers: {
    type: 'array',
    required: true,
    items: {
      code:         { type: 'string',  required: false },
      name:         { type: 'string',  required: false },
      capabilities: { type: 'array',   required: false },
    },
  },
})
